/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '@cashew/input';
import moment from 'moment';
import Button from '@cashew/button';
import { useEnterListener } from '@cashew/hooks';
import './index.css';
import ExportModal from './ExportModal';
import SelectComponent from '../../components/SelectComponent';

const { api } = require('@cashew/utils');

export default ({
  setLoading,
  useSelector,
  setRecords,
  records,
  setList,
  pageSize,
  pageNumber,
  setPageNumber,
  history,
  dispatch,
}: any) => {
  const { t } = useTranslation();
  const { token, selectedStore } = useSelector((state: any) => state.user);
  const [searchId, setSearchId] = useState('');
  const [searchBy, setSearchBy] = useState<string>('orderId');
  const [dateFrom, setDateFrom] = useState(
    moment().subtract(2, 'years').format('YYYY-MM-DD')
  );
  const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
  const [dateToError, setDateToError] = useState('');
  const [dateFromError, setDateFromError] = useState('');
  const [filterParams, setFilterParams] = useState();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [enterBtn, setEnterBtn] = useState(false);

  const numericInput = /^[0-9]+$/;

  const searchByData = [
    {
      key: 'orderId',
      value: 'Order ID',
    },
    {
      key: 'reference',
      value: 'Merchant order code',
    },
    {
      key: 'phoneNumber',
      value: 'Phone number',
    },
    {
      key: 'email',
      value: 'Email',
    },
    {
      key: 'nationalId',
      value: 'National ID',
    },
  ];

  const getOrdersApi = (resetPageNumber = true) => {
    setLoading(true);

    if (resetPageNumber && pageNumber !== 0) {
      setPageNumber(0);
      return;
    }

    const params: any = {
      page: pageNumber,
      size: pageSize,
      storeId: selectedStore > 0 ? selectedStore : null,
      status: 'CREATED',
      dateFrom,
      dateTo,
    };
    if (searchId && searchBy) {
      params[searchBy] = searchId.trim();
    }
    setFilterParams(params);
    api
      .get({
        endpoint: 'orders',
        params,
        headers: {
          Authorization: token,
        },
      })
      .then((resp: any) => {
        setRecords(resp.totalCount);
        setList(
          resp.data.map((item: any) => {
            const newItem = item;
            newItem.date = item.purchaseDate;
            newItem.status = item.orderStatus;
            newItem.goTo =
              item.productType === 'SUBSCRIPTION'
                ? 'subscriptions'
                : 'abandoned';
            newItem.merchantOrderCode = item.orderReference;
            return newItem;
          })
        );
      })
      .catch((err: any) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEnterListener(() => setEnterBtn((prev) => !prev));

  useEffect(() => {
    getOrdersApi();
  }, [selectedStore, dateFrom, dateTo, enterBtn]);

  useEffect(() => {
    setSearchId('');
  }, [searchBy]);

  useEffect(() => {
    getOrdersApi(false);
  }, [pageNumber, pageSize]);

  const getExcelReport = () => {
    api
      .get({
        endpoint: 'orders/excel',
        responseType: 'blob',
        params: filterParams,
        headers: {
          Authorization: token,
        },
      })
      .then((response: any) => {
        const [firstDate, secondDate] = new Date()
          .toLocaleString('no-nb')
          .split(',');
        const name = [
          ...firstDate.split('/'),
          ...secondDate.trim().split(':'),
        ].join('-');
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        const blob = response;
        const a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `Abandoned_orders_report_${name}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  const handleSelectChange = (selectedKey: string) => {
    setSearchId('');
    setSearchBy(selectedKey);
  };
  return (
    <>
      <div className="filters">
        <div className="filter-group">
          <div className="filter-input">
            <SelectComponent
              label="Search by"
              data={searchByData}
              selected={searchBy}
              onSelect={handleSelectChange}
            />
          </div>
          <div className="filter-input">
            <Input
              name="orderId"
              value={searchId}
              type="text"
              maxLength={searchBy === 'orderId' ? 14 : 100}
              onChange={(e: any) => {
                const searchValue = e.target.value;
                if (searchBy === 'orderId') {
                  if (searchValue.match(numericInput) || searchValue === '') {
                    setSearchId(searchValue);
                  }
                } else {
                  setSearchId(searchValue);
                }
              }}
            />
          </div>
          <div className="filter-input">
            <button
              type="button"
              className="btn blue"
              onClick={() => {
                getOrdersApi();
              }}
            >
              Search
            </button>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-input">
            <label>From</label>
            <Input
              name="dateFrom"
              value={dateFrom}
              error={dateFromError ? ' ' : ''}
              type="date"
              onChange={(e: any) => {
                setDateToError('');
                setDateFrom(moment(e.currentTarget.value).format('YYYY-MM-DD'));
                if (moment(e.currentTarget.value).isAfter(dateTo) && dateTo) {
                  setDateFromError(t('validation-less'));
                } else {
                  setDateFromError('');
                }
              }}
            />
            <span className="error-message">{dateFromError}</span>
          </div>

          <div className="filter-input">
            <span>To</span>
            <Input
              name="dateTo"
              value={dateTo}
              type="date"
              error={dateToError ? ' ' : ''}
              onChange={(e: any) => {
                setDateFromError('');
                setDateTo(moment(e.currentTarget.value).format('YYYY-MM-DD'));
                if (
                  moment(e.currentTarget.value).isBefore(dateFrom) &&
                  dateFrom
                ) {
                  setDateToError(t('validation-greater'));
                } else {
                  setDateToError('');
                }
              }}
            />
            <span className="error-message">{dateToError}</span>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-input" />

          <div className="filter-input">
            <Button
              extraClass={records ? 'btn blue' : ''}
              disabled={!records}
              onClick={() => setShowCancelModal(true)}
            >
              Export to Excel
            </Button>
          </div>
        </div>
      </div>
      <ExportModal
        showConfirmModal={showCancelModal}
        setShowConfirmModal={setShowCancelModal}
        token={token}
        history={history}
        dispatch={dispatch}
        getExcelReport={getExcelReport}
        records={records}
      />
    </>
  );
};
